<template>
  <!-- Sekce pro si_rent (půjčení čipu) -->
  <v-col v-for="service in localSiRent" :key="service.id" cols="12" md="2">
    <h3>{{ $t('event_settings.services.section_title_rent') }}</h3>
    <v-text-field
      v-model.number="service.price"
      @update:modelValue="val => service.price = (val === '' ? null : Number(val))"
      :label="$t('event_settings.services.price_label')"
      type="number"
      min="0"
      :suffix="`${currencySymbol(props.eventCurrency)}`"
      density="comfortable"
      :hint="$t('event_settings.services.price_hint')"
      :error-messages="validationErrors.si_rent[service.id] || []"

    />
  </v-col>

  <v-row>
    <v-col cols="12" md="2"><h2>{{ $t('event_settings.services.section_title_other') }}</h2></v-col>
    <v-col cols="12" md="10" class="d-flex flex-wrap gap-2">
      <v-row>
        <v-btn color="primary" class="w-100 w-md-auto order-2 order-md-1 mr-md-10 mt-1" @click="dialog = true" :prepend-icon="isLocked ? 'mdi-lock' : undefined"
                        :disabled="isLocked">{{ $t('event_settings.services.add_button') }}</v-btn>
        <v-btn color="green" @click="editService" :disabled="!isEditValid || isLocked" class="w-100 mb-2 w-md-auto order-1 order-md-2 mt-1" :prepend-icon="isLocked ? 'mdi-lock' : undefined">{{ $t('event_settings.services.save_button') }}</v-btn>
      </v-row>
    </v-col>
  </v-row>


  <v-row v-for="(variants, key, groupIndex) in groupedOtherServices" :key="key">
    <v-col cols="12" class="d-flex">
      <h3>{{ $t('event_settings.services.group_title') + ' ' + (groupIndex + 1) }}</h3>
      <v-icon @click="openDeleteDialog(key, groupIndex)" color="red" size="large" class="ml-3" :disabled="isLocked">mdi-delete</v-icon>
    </v-col>

    <v-col
      v-for="service in variants"
      :key="service.id"
      cols="12"
      md="2"
    >
      <h4 class="mb-3">{{ $t('event_settings.services.variant_label') }} {{ service.variant }}</h4>
      <v-text-field
        v-model="service.name"
        :label="$t('event_settings.services.name')"
        :rules="[v => !!v || $t('rules.required')]"
        maxlength="40"
        counter
        density="compact"
        :error-messages="validationErrors.edit[service.id]?.name || []"
        variant="outlined"
      />
      <v-text-field
        v-model="service.price"
        :label="$t('event_settings.services.price')"
        type="number"
        :suffix="`${currencySymbol(props.eventCurrency)}`"
        density="compact"
        :error-messages="validationErrors.edit[service.id]?.price || []"
        variant="outlined"
      />
      <v-text-field
        v-model.number="service.limit"
        @update:modelValue="val => service.limit = (val === '' ? null : Number(val))"
        :label="$t('event_settings.services.limit')"
        type="number"
        density="compact"
        variant="outlined"
      />
      <v-text-field
        v-model="service.description"
        :label="$t('event_settings.services.description')"
        type="text"
        maxlength="130"
        counter
        density="compact"
        variant="outlined"
      />

    </v-col>

  </v-row>

  <!-- Dialog pro smazání služby -->
  <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>{{ $t('event_settings.services.delete_title') }}</v-card-title>
        <v-card-text>
        {{ $t('event_settings.services.delete_text_prefix') }}
        <strong>
          {{ $t('event_settings.services.delete_text_bold', [serviceGroupIndexToDelete + 1]) }}
        </strong>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialogDelete = false">{{ $t('general.cancel') }}</v-btn>
          <v-spacer />
          <v-btn color="red" @click="deleteService(serviceKeyToDelete)">{{ $t('general.delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  

  <!-- Dialog pro vytvoření nové služby s více variantami -->
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title>{{ $t('event_settings.services.title_create') }}</v-card-title>
      <v-card-text>
        <div v-for="(variant, index) in newServiceVariants" :key="index">
          <div class="d-flex align-center justify-space-between">
            <strong>{{ $t('event_settings.services.variant_label') }} #{{ index + 1 }}</strong>
            <v-icon
              v-if="newServiceVariants.length > 1"
              color="red"
              @click="removeVariant(index)"
            >mdi-delete</v-icon>
          </div>

          <v-text-field
            v-model="variant.name"
            :label="$t('event_settings.services.name')"
            maxlength="40"
            counter
            :error-messages="validationErrors.newService[index]?.name || []"
            density="comfortable"
          />

          <v-text-field
            v-model="variant.price"
            :label="$t('event_settings.services.price')"
            type="number"
            :suffix="`${currencySymbol(props.eventCurrency)}`"
            :error-messages="validationErrors.newService[index]?.price || []"
            density="comfortable"
          />

          <v-text-field
            v-model.number="variant.limit"
            @update:modelValue="val => variant.limit = (val === '' ? null : Number(val))"
            :label="$t('event_settings.services.limit')"
            type="number"
            density="comfortable"
          />

          <v-text-field
            v-model="variant.description"
            :label="$t('event_settings.services.description')"
            type="text"
            maxlength="130"
            counter 
            density="comfortable"
          />

        </div>

        <v-btn variant="text" color="primary"  @click="addVariant">+ {{ $t('event_settings.services.add_variant') }}</v-btn>

      </v-card-text>

      <v-card-actions>
        <v-btn text @click="dialog = false">{{ $t('general.cancel') }}</v-btn>
        <v-spacer />
        <v-btn color="green" @click="createService" :disabled="!isCreateValid">{{ $t('general.create') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


</template>

<script setup>
import { ref, watch, computed } from 'vue'
import apiClient from '/api.js';
import { useRoute } from 'vue-router'
import { useSnackbarStore } from '@/stores/snackbarStore'
import { useI18n } from 'vue-i18n'
import { currencySymbol } from '@/components/const/enums.js';


const props = defineProps({
  siRent: {
    type: Array,
    default: () => []
  },
  otherService: {
    type: Array,
    default: () => []
  },
  eventClosed: { 
    type: Boolean, 
    default: false 
  },
  eventCurrency: {
    type: String,
    default: 'CZK'
  }
})

const emit = defineEmits(['refresh', 'submit'])

const { t } = useI18n()
const route = useRoute()
const snackbar = useSnackbarStore()
const dialog = ref(false)

const isLocked = computed(() => !!props.eventClosed)
const dialogDelete = ref(false)
const serviceKeyToDelete = ref(null)
const serviceGroupIndexToDelete = ref(null)
const openDeleteDialog = (key, groupIndex) => {
  serviceKeyToDelete.value = key
  serviceGroupIndexToDelete.value = groupIndex
  dialogDelete.value = true
}

const newServiceVariants = ref([
  { name: '', price: null, limit: null }
])

const localOtherServices = ref([])
const localSiRent = ref([])

// props → lokální kopie
watch(
  () => props.otherService,
  (val) => {
    localOtherServices.value = val.map(s => ({ ...s }))
  },
  { immediate: true }
)

watch(
  () => props.siRent,
  (val) => {
    localSiRent.value = val.map(s => ({ ...s }))
  },
  { immediate: true }
)


// VALIDACE /////////////

const validationErrors = ref({
  newService: {
    name: [],
    price: []
  },
  edit: {},
  si_rent: {}
})

watch(localSiRent, (val) => {
  const errors = {}
  val.forEach(service => {
    if (service.price !== null && service.price !== '' && parseInt(service.price) < 0) {
      errors[service.id] = [t('event_settings.services.price_negative')]
    } else {
      errors[service.id] = []
    }
  })
  validationErrors.value.si_rent = errors
}, { deep: true, immediate: true })


watch(newServiceVariants, (val) => {
  validationErrors.value.newService = val.map(variant => ({
    name: !variant.name?.trim() ? [t('rules.required')] : [],
    price:
      variant.price === null || variant.price === '' ? [t('rules.required')]
      : []
  }))
}, { deep: true, immediate: true })


watch(localOtherServices, (val) => {
  const errors = {}
  val.forEach(service => {
    errors[service.id] = {
      name: !service.name?.trim() ? [t('rules.required')] : [],
      price:
        service.price === null || service.price === '' ? [t('rules.required')]
        : []
    }
  })
  validationErrors.value.edit = errors
}, { deep: true, immediate: true })


const isValidSiRent = computed(() => {
  return localSiRent.value.every(s =>
    s.price === null || s.price === '' || parseInt(s.price) >= 0
  )
})

const isEditValid = computed(() => {
  const servicesValid = Object.values(validationErrors.value.edit).every(err =>
    err.name.length === 0 && err.price.length === 0
  )
  return servicesValid && isValidSiRent.value
})

const isCreateValid = computed(() => {
  return validationErrors.value.newService.every(err =>
    err.name.length === 0 && err.price.length === 0
  )
})

// seskupení služeb na základě klíče
const groupedOtherServices = computed(() => {
  const grouped = {}
  for (const service of localOtherServices.value) {
    if (!grouped[service.key]) {
      grouped[service.key] = []
    }
    grouped[service.key].push(service)
  }
  // seřadit varianty uvnitř skupiny
  for (const key in grouped) {
    grouped[key].sort((a, b) => a.variant - b.variant)
  }
  return grouped
})


// Konec VALIDACE /////////////

const addVariant = () => {
  newServiceVariants.value.push({ name: '', price: null, limit: null })
}

const removeVariant = (index) => {
  newServiceVariants.value.splice(index, 1)
}

// Vytvoření nové služby
const createService = async () => {

  if (!isCreateValid.value) return

  try {
    const eventId = route.params.id
    const payload = newServiceVariants.value.map((variant, index) => ({
      name: variant.name,
      price: variant.price,
      limit: variant.limit,
      type: 'other',
      variant: index + 1,
      description: variant.description || ''
    }))

    await apiClient.post(`race_service/?event_id=${eventId}&create=true`, payload)

    dialog.value = false
    newServiceVariants.value = [{ name: '', price: null, limit: null }]

    snackbar.success(t('event_settings.services.create_success'))
    emit('refresh')
  } catch (err) {
    if (err.response?.data?.error) {
      snackbar.error(err.response.data.error)
    } else {
      snackbar.error(t('event_settings.services.create_error'))
    }
    console.error(err)
  }
}


const editService = async () => {
  try {
    const payload = {
      si_rent: localSiRent.value.map(s => ({
        id: s.id,
        price: s.price ?? null
      })),
      other_service: localOtherServices.value.map(s => ({
        id: s.id,
        name: s.name,
        price: s.price,
        limit: s.limit,
        description: s.description,
        type: 'other',
        variant: s.variant || 1
      }))
    }

    await apiClient.put(`race_service/`, payload)

    snackbar.success(t('event_settings.services.update_success'))
    emit('refresh')

  } catch (err) {
    if (err.response?.data?.error) {
      snackbar.error(err.response.data.error)
    } else {
      snackbar.error(t('event_settings.services.update_error'))
    }
    console.error(err)
  }
}

const deleteService = async () => {
  if (!serviceKeyToDelete.value) return

  try {
    await apiClient.delete(`race_service/?service_key=${serviceKeyToDelete.value}`)
    dialogDelete.value = false
    serviceKeyToDelete.value = null
    snackbar.success(t('event_settings.services.delete_success'))
    emit('refresh')
  } catch (err) {
    if (err.response?.data?.error) {
      snackbar.error(err.response.data.error)
    } else {
      snackbar.error(t('event_settings.services.delete_error'))
    }
    console.error(err)
  }
}



</script>
